import { FETCH_QUOTE, CHANGE_COLOR } from '../actions/types';

const initialState = {
	color: '',
	quoteInfo: ''
}

const fetchReducer = (state = initialState, action) => {
	
	switch(action.type){
		case FETCH_QUOTE: 
			return {
				...state,
				quoteInfo: action.payload
			};

		case CHANGE_COLOR: 
			return {
				...state,
				color: action.payload
			};

		default: 
			return state;
	}
}

export default fetchReducer; 
